import { extend, configure } from 'vee-validate';
import { required, email, min, confirmed } from 'vee-validate/dist/rules';
import api from './api';
import i18n from './i18n';

configure({
    defaultMessage: (field, values) => i18n.t(`validation.${values._rule_}`, values)
});

extend('required', required);
extend('email', {
    params: email.params,
    validate: value => email.validate(value.trim())
});
extend('min', min);
extend('confirmed', confirmed);
extend('isTrue', {
    validate: value => value
});
extend('newPassword', {
    validate: (value, { oldPassword }) => String(value) !== String(oldPassword),
    params: [ 'oldPassword' ]
});

const emailExists = async email => {
    try {
        let response = await api.post('/app/registration/mail/check', {
            mail: email
        });

        return response.data;
    }
    catch (e) {
        return false;
    }
};

const validPassword = async password => {
    try {
        let response = await api.post('/app/account/password/check', {
            password
        });

        return response.data;
    }
    catch (e) {
        return false;
    }
};

extend('emailNotExists', {
    validate: async value => {
        let response = await emailExists(value);
        return !response.exists;
    }
});

extend('validPassword', {
    validate: async value => {
        let response = await validPassword(value);
        return response.match;
    }
});

extend('emailExists', {
    validate: async value => {
        let response = await emailExists(value);
        return response.activated;
    }
});

extend('phone', {
    validate: value => value.match(/^(\+7|7|8)(\d{10})$/)
});
